import React from 'react';
import { Box } from '@chakra-ui/react';

interface ISummaryListItem {
  label?: React.ReactNode;
  value?: React.ReactNode;
  subvalue?: React.ReactNode;
}

export const SummaryListItem = (props: ISummaryListItem) => {
  const { label, value, subvalue } = props;

  return (
    <Box as="li" lineHeight={5} mb={2} _last={{ mb: 0 }} ml={5} sx={{ fontVariantNumeric: 'tabular-nums' }}>
      {label && (
        <Box fontWeight={'normal'} fontSize={'sm'} color={'muted'}>
          {label}:
        </Box>
      )}

      <Box fontWeight={'medium'}>{value}</Box>

      {subvalue && (
        <Box color={'muted'} fontSize={'sm'} fontWeight={'normal'}>
          {subvalue}
        </Box>
      )}
    </Box>
  );
};
